import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { Project } from '../interfaces/project';
import {AnnualSchoolProfileService} from "../services/annual-school-profile.service";
import {AnnualSchoolProfile} from "../interfaces/annual-school-profile";

@Component({
  standalone: true,
  imports: [
    TitleCasePipe,
    DatePipe,
  ],
  selector: 'app-project-card',
  templateUrl: './project-card.component.html',
  styleUrl: './project-card.component.css'
})

export class ProjectCardComponent {
  @Input() project!: Project;
  @Output() cardClicked: EventEmitter<String> = new EventEmitter();
  annualProfile: AnnualSchoolProfile[] = [];

  constructor(private annualService: AnnualSchoolProfileService) {}

  async ngOnInit() {
    this.annualProfile = await this.annualService.getAllProfiles();
  }

  onCardClick() {
    if (!this.project.id) {
      alert("Project has no ID property.");
      return;
    }
    this.cardClicked.emit(this.project.id);
  }

  getAssociatedAnnualProfileTeacher(): string {
    if (!this.project.school || !this.annualProfile) return '';

    const profile = this.annualProfile.find(p =>
      p.school.trim().toLowerCase() === this.project.school.trim().toLowerCase() &&
      !p.isDeleted
    );
    if (!profile?.ghsRepresentativeName) return '';
    return profile.ghsRepresentativeName.replace(/\s*teacher$/i, '');
  }

  isCategorySelected(){

  }
}
